import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import './PageLoading.css';

interface PageLoadingProps {
  tip?: string;
  fullScreen?: boolean;
}

const PageLoading = ({ tip = 'Loading...', fullScreen = false }: PageLoadingProps) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;

  return (
    <div className={`page-loading ${fullScreen ? 'fullscreen' : ''}`}>
      <Spin indicator={antIcon} tip={tip} size="large" />
    </div>
  );
};

export default PageLoading;

